import React, { useState } from 'react'
import PropTypes from 'prop-types'
import connect from 'react-redux/es/connect/connect'
import getStoryFromStage from '../../../redux/selectors/getStoryFromStage'
import { progressBattle } from '../../../redux/actions/game/battle.actions'

const StoryMode = (props) => {
    const [storyStep, setStoryStep] = useState(0)
    const { story, progressAfterStory } = props

    let storyTemplate = ''

    const handleClick = () => {
        setStoryStep(storyStep + 1)
        if (!story[storyStep + 1]) {
            setStoryStep(0)
            progressAfterStory()
        }
    }

    function hideStory() { storyTemplate = ('') }

    function showStory(avatar, name, side, text) {
        storyTemplate = (/* eslint-disable-next-line */
            <div className="storyMode" onClick={() => handleClick()}>
                <div className="storyMode__wrapper">
                    <div className={`storyMode__actor storyMode__actor--${side}`}>
                        <div className="storyMode__avatar">{avatar}</div>
                        <div className="storyMode__name">{name}</div>
                    </div>
                    <div className="storyMode__text">{text}</div>
                </div>
            </div>
        )
    }

    if (!story || story.length <= 0) {
        hideStory()
    }
    if (story && story[storyStep]) {
        const {
            avatar, name, side, text,
        } = story[storyStep]
        showStory(avatar, name, side, text)
    }

    return storyTemplate
}

StoryMode.propTypes = {
    story: PropTypes.array.isRequired,
    progressAfterStory: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    story: getStoryFromStage(state),
})

const mapDispatchToProps = dispatch => ({
    progressAfterStory: () => dispatch(progressBattle()),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(StoryMode)
